import { REGISTRATION_STATUS } from '@constants/registration';
import { getRequest } from '@helpers/api';

import { type FetchEntityJurisdictions } from './types';

/**
 * Fetch a list of jurisdictions for a specific entity
 */
export const fetchEntityJurisdictions = ({
  limit,
  offset,
  term,
  entityId,
  hasClientTransactionTypes,
  includeNonManaged,
  registrationStatuses = [REGISTRATION_STATUS.ACTIVE],
}: FetchEntityJurisdictions = {}) =>
  getRequest('auth/entityJurisdictions/', {
    limit,
    offset,
    search: term,
    entity: entityId,
    has_client_transaction_types: hasClientTransactionTypes,
    include_non_managed: includeNonManaged,
    registration_statuses: registrationStatuses,
  });

/**
 * Fetch a single entity jurisdiction detail
 */
export const fetchEntityJurisdiction = (
  entityJurisdictionId: string,
  includeNonManaged?: boolean
) =>
  getRequest(`auth/entityJurisdictions/${entityJurisdictionId}/`, {
    include_non_managed: includeNonManaged,
  });
